import * as React from 'react';
import {
  Grid, Card, CardHeader, CardContent, CardActions, Box, Typography, Paper, TextField, Button, CircularProgress,
} from '@material-ui/core';
import { Autocomplete, Skeleton } from '@material-ui/lab';
import type { ISkillLevelType } from './SkillLevelTypeInterfaces';
import GetSkillLevelGroups from '../../lib/SWRfetchers/getSkillLevelGroups';

interface SkillLevelTypeAddProps {
  formValues: ISkillLevelType,
  setFormValues: (values: ISkillLevelType) => void,
  secondaryButtonAction: () => void,
  primaryButtonAction: () => void,
  interfaceType: string,
  loading: boolean,
}

const SkillLevelTypeAdd: React.FC<SkillLevelTypeAddProps> = ({
  formValues, setFormValues, secondaryButtonAction, primaryButtonAction, interfaceType, loading,
}) => {
  const { skillLevelGroups } = GetSkillLevelGroups();

  return (
    <Paper>
      <Card>
        <CardHeader
          title={(
            <Typography variant="h6" display="inline">{interfaceType === 'Add' ? 'Add Skill Level Type' : 'Edit Skill Level Type'}</Typography>
        )}
          disableTypography
        />
        <CardContent>
          <Grid container xs={12}>
            <Grid item md={4} xs={4}>
              <Box px={2}>
                { skillLevelGroups ? (
                  <Autocomplete
                    autoHighlight
                    autoSelect
                    options={skillLevelGroups || []}
                    getOptionLabel={(option) => option.name || ''}
                    getOptionSelected={(option, value) => option?.name === value?.name}
                    // prop spreading is directly from MUI tsx example
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    renderInput={(params) => <TextField {...params} label="Group Name" variant="outlined" id="skillLevelGroup-autocomplete-input" />}
                    value={skillLevelGroups.find((x) => x?.name === formValues?.group)}
                    onChange={(event, value) => {
                      if (value !== null) {
                        setFormValues({ ...formValues, group: value?.name || '' });
                      } else {
                        setFormValues({ ...formValues, group: '' });
                      }
                    }}
                  />
                ) : (
                  <Skeleton width="100%" height="56px" variant="rect" />
                )}
              </Box>
            </Grid>
            <Grid item md={4} xs={4}>
              <Box pl={2}>
                <TextField
                  id="skillLevelType-value-input"
                  value={formValues?.name ?? null}
                  type="text"
                  label="Skill Level Type"
                  variant="outlined"
                  fullWidth
                  onChange={(e) => {
                    const data = e.target.value;
                    if (data) {
                      const tempFormValues: ISkillLevelType = { ...formValues, name: data };
                      setFormValues(tempFormValues);
                    } else {
                      const tempFormValues: ISkillLevelType = { ...formValues, name: null };
                      setFormValues(tempFormValues);
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item md={3} xs={3}>
              <Box pl={2}>
                <TextField
                  id="skillLevelType-Level-input"
                  value={formValues?.level ?? undefined}
                  type="number"
                  label="Level"
                  variant="outlined"
                  fullWidth
                  onChange={(e) => {
                    const data = parseInt(e.target.value, 10);
                    if (data) {
                      const tempFormValues: ISkillLevelType = { ...formValues, level: data };
                      setFormValues(tempFormValues);
                    } else {
                      const tempFormValues: ISkillLevelType = { ...formValues, level: undefined };
                      setFormValues(tempFormValues);
                    }
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Grid container direction="row-reverse" spacing={2}>
            <Grid item>
              <Button disabled={loading} color="primary" variant="contained" onClick={primaryButtonAction}>
                {loading ? <CircularProgress size={25} /> : <>{interfaceType === 'Add' ? 'ADD SKILL LEVEL TYPE' : 'EDIT SKILL LEVEL TYPE'}</>}
              </Button>
            </Grid>
            <Grid item>
              <Button variant="text" color="secondary" onClick={secondaryButtonAction}>{'CANCEL'}</Button>
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    </Paper>
  );
};
export default SkillLevelTypeAdd;
